import { BOPIS } from '@/data/constants/checkout';
import { SHIP_MODE_CODE } from '@/data/constants/order';
import { CDN_BASE_URL } from 'shared/custom/constants/commonConstants';

export enum STEP_STATUS {
	ACTIVE = 'active',
	COMPLETED = 'completed',
	PENDING = 'pending',
}

export const CHECKOUT_STEPS = {
	CONTACT: 0,
	ADDRESS: 1,
	SHIPPING: 2,
	PAYMENT: 3,
} as const;

export const PAYMENT = {
	policies: {
		COD: true,
		MasterCard: true,
		VISA: true,
		AMEX: true,
		oxxo: true,
		giftCard: true,
		openPay: true,
		paypal: true,
		creditAr: true,
	},
	paymentMethodName: {
		cod: 'PayInStore',
		mc: 'MasterCard',
		visa: 'VISA',
		amex: 'AMEX',
		carnet: 'CARNET',
		oxxo: 'Oxxo',
		giftCard: 'GiftCard',
		openPay: 'OpenPay',
		paypal: 'PayPal',
		master: 'Master Card',
		creditAr: 'CreditAR',
	} as const,
};

// Images on CDN
export const PAYMENT_ICONS_CDN = {
	openPay: `${CDN_BASE_URL}/layout/checkout/PBT-Black.svg`,
	paypal: `${CDN_BASE_URL}/layout/checkout/Paypal.png`,
	oxxoPay: `${CDN_BASE_URL}/layout/checkout/oxxo.png`,
	oxxoPayLogo: `${CDN_BASE_URL}/layout/checkout/oxxo-pay.png`,
	cvv: `${CDN_BASE_URL}/layout/checkout/visa-mastercard-cvv.svg`,
};

// Images on local server
export const IMAGES_HDMX_PUBLIC = {
	oxxoPay: '/HDMX/images/oxxo-logo.svg',
	visa: '/HDMX/images/visa-color.png',
	mc: '/HDMX/images/mastercard-color.png',
	amex: '/HDMX/images/amex-color.png',
	carnet: '/HDMX/images/Carnet-01.png',
	creditScore: '/HDMX/images/credit-score.svg',
};

export type CardKey = keyof typeof IMAGES_HDMX_PUBLIC;
export const CARD_ALIASES: Record<string, CardKey> = {
	visa: 'visa',
	'master card': 'mc',
	mastercard: 'mc',
	maestro: 'carnet',
	carnet: 'carnet',
	amex: 'amex',
};

export const SPLIT = 'split';

export const DELIVERY_METHODS = {
	DELIVERY: SHIP_MODE_CODE.MAIL,
	BOPIS,
	SPLIT,
};

export const EMPTY_DATE = '  /  ';

export const COOKIES_PAYMENT = {
	cookieName: 'WC_Payment_Content',
	paymentMethodName: {
		PayAtStore: 'PayAtStore',
		mc: 'Cybersource',
		VISA: 'Cybersource',
		amex: 'Cybersource',
		carnet: 'Cybersource',
		Oxxo: 'OXXO',
		giftCard: 'GiftCard',
		OpenPay: 'Transfer',
		PayPal: 'PaypalExpress',
		master: 'Cybersource',
		pointsBbva: 'PuntosBBVA',
	},
};

export const DECLINED_ORDER = 'orden-declinada';
export const MSI_ONLINE = '/condiciones-promociones-meses-sin-intereses-en-linea';

export const PAYPAL_LINK_ACCOUNT_BUTTON_CONTAINER_ID = 'paypal-button-container-BA';
export const PAYPAL_MANAGE_ACCOUNT_BUTTON_CONTAINER_ID = 'paypal-button-container-BA-CardAdmin';
export const PAYPAL_GUEST_USER_PAY_BUTTON_CONTAINER_ID = 'paypal-button-container';

export const ERR_PAYPAL_GENERIC = 'ERR_PAYPAL_GENERIC';
export const ERR_PAYPAL_TRANSACTION_REJECTED = 'ERR_PAYPAL_TRANSACTION_REJECTED';

export const CHECKOUT_CURRENT_ADDRESS_KEY = 'CHECKOUT_CURRENT_ADDRESS_ID';

export const ESPOT_NAMES = {
	PRO_CHECKOUT_PAYMENT_PAYBYTRANSFER_CONTENT_STEPS:
		'PRO_Checkout_Payment_PayByTransfer-Content-Steps',
	CHECKOUT_PAYMENT_PAYBYTRANSFER_CONTENT_STEPS: 'Checkout_Payment_PayByTransfer-Content-Steps',
	PRO_CHECKOUT_PAYMENT_PAY_AT_STORE_CONTENT: 'PRO_Checkout_Payment_PayAtStore-Content',
	CHECKOUT_PAYMENT_PAY_AT_STORE_CONTENT: 'Checkout_Payment_PayAtStore-Content',
	PRO_CHECKOUT_PAYMENT_PROMOTIONS_BANNER: 'PRO_Checkout_Payment-Promotions-Banner',
	CHECKOUT_PAYMENT_PROMOTIONS_BANNER: 'Checkout_Payment-Promotions-Banner',
	PRO_CHECKOUT_PAYMENT_PROMOTIONS_DRAWER_INFO: 'PRO_Checkout_Payment-Promotions-Drawer-Info',
	CHECKOUT_PAYMENT_PROMOTIONS_DRAWER_INFO: 'Checkout_Payment-Promotions-Drawer-Info',
	CHECKOUT_PAYMENT_OXXO_CONTENT: 'Checkout_Payment_Oxxo-Content',
};

export const PAYMENT_INSTRUCTIONS_VARIANTS = {
	TRANSFER: 'transfer',
	OXXO: 'oxxo',
	STORE: 'store',
} as const;

export type PaymentInstructionsVariant =
	(typeof PAYMENT_INSTRUCTIONS_VARIANTS)[keyof typeof PAYMENT_INSTRUCTIONS_VARIANTS];

export const PAYMENT_INSTRUCTIONS_ESPOT_NAMES: Record<PaymentInstructionsVariant, string> = {
	transfer: 'Checkout_Payment_PayByTransfer-Drawer-Content',
	oxxo: 'Checkout_Payment_Oxxo-Drawer-Content',
	store: 'Checkout_Payment_PayAtStore-Drawer-Content',
};
export const ADDRESS_FORM_SAVE = 'address-form-save';

export const RETURN_TO_CART_ID = 'returnToCart';
export const CHECKOUT_STEP1 = 'checkoutStep1';
export const EDIT_STEP1 = 'editStep1';
export const EDIT_STEP2 = 'editStep2';
export const EDIT_STEP3 = 'editStep3';
export const CHECKOUT_STEP2_ADDRESS = 'checkoutStep2Address';
export const CHECKOUT_STEP2_HOME_DELIVERY = 'checkoutStep2HomeDelivery';
export const EDIT_CHECKOUT_STEP2_HOME_DELIVERY = 'editStep2Address';
export const IS_CHECKOUT_REFRESHED_KEY = 'isCheckoutRefreshed';
export const BLOCK_ZIP_CODE_LIST_ITEMS_KEY = 'blockZipCodeOrderItems';
